export const HEADERS = [
    {label: "Тип ИНС", orderingField: "tissue"},
    {label: "Имя файла", orderingField: "name"},
    {label: "Дата загрузки", orderingField: "load_date"},
    {label: "Статус"},
    {label: "Открыть"},
    {label: "Дата обработки", orderingField: "processing_date"},
    {label: "Результат", orderingField: "result"},
    {label: "Аннотация", orderingField: "conclusion"},
    {label: "Статус просмотра"}
];
